var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCapsuleMaterialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.7,
    y: 4.7,
    width: 16.6,
    height: 12.6,
    rx: 2.8,
    stroke: "#36F6FF",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9.4,
    r: 1.6,
    stroke: "#36F6FF",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 15.6L8.1 11.9C8.7 11.4 9.6 11.5 10.1 12.1L13.2 15.7M12.1 14.4L14 12.8C14.6 12.3 15.4 12.3 16 12.8L18.6 15.1",
    stroke: "#36F6FF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCapsuleMaterialsIcon);
export default __webpack_public_path__ + "static/media/tc_cab_capsule_materials_icon.18d649612794558f06cda851e36eca3d.svg";
export { ForwardRef as ReactComponent };